import React, { useEffect, useState } from "react"

import "./index.less"
import { Button, Checkbox, Input, Popover, Tag, Tooltip } from "antd"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { PlusCircleFilled } from "@ant-design/icons"
import pencilSvg from "../../../../images/pencil.svg"
import deleteredSvg from "../../../../images/delete.svg"
import SkeletonButton from "antd/lib/skeleton/Button"
import { CircleDeleteIcon } from "../../../../icons/svg/iconCircleDelete"
import { CirclePencilIcon } from "../../../../icons/svg/iconCirclePencil"

const { TextArea } = Input

const MAX_ANSWER_LENGTH = 200

export function MultipleChoiceForm(props) {
  const [inputAnswer, setInputAnswer] = useState("")

  const [hasMaxTags, setHasMaxTags] = useState(false)

  const {
    multipleAnswerList,
    onClickRemoveMultipleChoice,
    onClickaddAnswerChoice,
    onClickEditMultipleChoice,
    handleOnChangeEdit,
    handleOnEnterEdit,
    onChangeMultipleChoiceCheck,
    isMultipleChoiceCkecked,
    isValidMultipleChoice,
  } = props

  useEffect(() => {
    if (multipleAnswerList.length < 20) {
      setHasMaxTags(false)
    } else {
      setHasMaxTags(true)
    }
  }, [multipleAnswerList])

  const handleInputChange = (e) => {
    setInputAnswer(e.target.value.trimStart())
  }

  // antd's TextArea onChange silently discards the whole paste (reverts to the
  // previous value) when maxLength is set and the resulting cursor position
  // isn't detected as the end of the field, so paste is handled manually here.
  const handlePasteAnswer = (e) => {
    e.preventDefault()
    const pastedText = (e.clipboardData || window.clipboardData).getData("text")
    const { selectionStart, selectionEnd } = e.target
    const newValue =
      inputAnswer.slice(0, selectionStart) +
      pastedText +
      inputAnswer.slice(selectionEnd)
    setInputAnswer(newValue.trimStart().slice(0, MAX_ANSWER_LENGTH))
  }

  const handleAddMultipleChoiceTag = () => {
    if (multipleAnswerList.length < 20) {
      onClickaddAnswerChoice(inputAnswer.trimEnd())
      setInputAnswer("")
      setHasMaxTags(false)
    } else {
      setHasMaxTags(true)
    }
  }

  const renderMultipleChoiceTags = () => {
    if (multipleAnswerList.length > 0) {
      return multipleAnswerList.map((tag, index) => {
        return (
          <div key={index} className="multipleAnswersContainer">
            <Tag
              style={{
                minWidth: 452,
                display: "flex",
                fontSize: 12,
                padding: "0px",
                margin: "8px 0px",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <TextArea
                value={tag.answer}
                autoSize
                bordered={!tag.editTagIsDisabled}
                style={{
                  margin: "3px 0px 3px 8px",
                  height: 27,
                  width: 368,
                  paddingLeft: 4,
                }}
                onChange={(e) => handleOnChangeEdit(e, index)}
                onPressEnter={(e) => handleOnEnterEdit(e, index)}
                onBlur={(e) => handleOnEnterEdit(e, index)}
                disabled={tag.editTagIsDisabled}
              />
              <div className="MultipleChoicesAnswers__TagsButtons">
                <Tooltip title="Editar">
                  <Button
                    disabled={props.disabledFields}
                    type="link"
                    className="MultipleChoicesAnswers__TagsButtons--pencil"
                    icon={<CirclePencilIcon disabled={props.disabledFields} />}
                    onClick={() => {
                      props.disabledFields
                        ? null
                        : onClickEditMultipleChoice(index)
                    }}
                  />
                </Tooltip>
                <Tooltip title="Eliminar">
                  <Button
                    disabled={props.disabledFields}
                    type="link"
                    className="MultipleChoicesAnswers__TagsButtons--delete"
                    icon={<CircleDeleteIcon disabled={props.disabledFields} />}
                    onClick={() => {
                      props.disabledFields
                        ? null
                        : onClickRemoveMultipleChoice(index)
                    }}
                  />
                </Tooltip>
              </div>
            </Tag>
          </div>
        )
      })
    }
  }

  const renderMultipleChoiceCheck = () => {
    const contentMultipleChoice = () => (
      <div
        style={{
          maxWidth: 250,
          fontSize: 13,
          textAlign: "center",
        }}>
        Los encuestados pueden seleccionar{" "}
        <span style={{ fontWeight: 600 }}>más de una opción</span> al contestar
      </div>
    )

    return (
      <div className="MultipleChoiceCheck">
        <Checkbox
          disabled={props.disabledFields}
          checked={isMultipleChoiceCkecked}
          onChange={(e) => onChangeMultipleChoiceCheck(e.target.checked)}>
          <div className="MultipleChoiceCheck__Content">
            <span>Es posible marcar más de una respuesta</span>
            <Popover content={contentMultipleChoice}>
              <QuestionIcon style={{ marginLeft: 8 }} />
            </Popover>
          </div>
        </Checkbox>
      </div>
    )
  }

  const renderMultipleChoiceInput = () => {
    let buttonAddIsDisable = inputAnswer.length <= 0

    const contentAddMultipleChoiceInput = () => (
      <div
        style={{
          maxWidth: 250,
          fontSize: 13,
          textAlign: "center",
        }}>
        Máximo de opciones a agregar: 20.
      </div>
    )

    const handleOnPressEnterAdd = (e) => {
      e.preventDefault()
      handleAddMultipleChoiceTag()
    }

    return (
      <div className="MultipleChoicesAnswers">
        <TextArea
          disabled={props.disabledFields}
          placeholder="Escribe aquí una opción para agregarla..."
          value={inputAnswer}
          showCount={false}
          maxLength={MAX_ANSWER_LENGTH}
          autoSize
          onChange={handleInputChange}
          onPaste={handlePasteAnswer}
          style={{ maxWidth: 452 }}
          onPressEnter={(e) => handleOnPressEnterAdd(e)}
        />
        <div className="MultipleChoicesAnswers__AddButton">
          {hasMaxTags && (
            <Popover content={contentAddMultipleChoiceInput}>
              <Button
                shape="circle"
                onClick={handleAddMultipleChoiceTag}
                style={{ border: "none", backgroundColor: "white" }}
                disabled
                icon={
                  <PlusCircleFilled
                    style={{
                      fontSize: 24,
                      border: "none",
                      color: "#CAC8C8",
                      margin: 0,
                    }}
                  />
                }
              />
            </Popover>
          )}
          {!hasMaxTags && (
            <Tooltip title="Agregar">
              <Button
                shape="circle"
                onClick={handleAddMultipleChoiceTag}
                style={{ border: "none", backgroundColor: "white" }}
                disabled={buttonAddIsDisable}
                icon={
                  <PlusCircleFilled
                    style={{
                      fontSize: 24,
                      border: "none",
                      color: buttonAddIsDisable ? "#CAC8C8" : "#2694FC",
                      margin: 0,
                    }}
                  />
                }
              />
            </Tooltip>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="MultipleChoiceForm">
      <div>
        <div className="Answers">
          <div className="Answers__Header">
            <div className="Answers__Header--title">Respuestas*</div>
          </div>
          <div>
            {renderMultipleChoiceCheck()}
            <div className="Answers__Scroll">
              {renderMultipleChoiceInput()}
              <div className="MultipleChoicesAnswers__Tags">
                {renderMultipleChoiceTags()}
                {!isValidMultipleChoice && (
                  <p style={{ color: "#E37879", margin: 0, fontSize: 13 }}>
                    Es obligatorio crear{" "}
                    <span style={{ fontWeight: 600 }}>2 respuestas</span> como
                    mínimo
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

MultipleChoiceForm.propTypes = {}

export default MultipleChoiceForm
